import { Box } from '@zillow/constellation-10';

export default function ConversationActionsWrapper({ children }: { children: React.ReactNode }) {
  return (
    <Box
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        flexDirection: 'row',
        maxWidth: 'fit-content',
      }}
    >
      {children}
    </Box>
  );
}
